module.exports = __webpack_public_path__ + "static/media/selfColoredPencil.720e87b0.jpg";